import React, { ReactNode } from 'react'

export enum AlertType {
  Primary = 'alert-primary',
  Secondary = 'alert-secondary',
  Success = 'alert-success',
  Danger = 'alert-danger',
  Warning = 'alert-warning',
  Info = 'alert-info',
  Light = 'alert-light',
  Dark = 'alert-dark'
}

export interface AlertProps {
  readonly type: AlertType
  readonly children: ReactNode
  readonly className?: string
}

export function Alert({ type, children, className }: AlertProps): JSX.Element {
  return (
    <div className={`${className} alert ${type}`} role='alert'>
      {children}
    </div>
  )
}
